import { jsx as _jsx } from "react/jsx-runtime";
import { BoxPrimitive } from '#pplx/frontend/aether/primitives/BoxPrimitive/index.js';
import { AskInputIncognitoHint } from '#pplx/frontend/apps/ask/ask-input/ask-input-attributions/components/AskInputIncognitoHint.js';
export function ComposerIncognitoHint() {
    return (_jsx(BoxPrimitive, { display: "flex", align: "center", className: "empty:hidden", children: _jsx(AskInputIncognitoHint, { show: true }) }));
}
//# sourceMappingURL=ComposerIncognitoHint.js.map